import { FIELD_PATHS } from '@funnels/constants';
import { LiabilityEntityIndex } from '@funnels/types';
import { DatePickerInputField } from '@funnels/ui-components';
import { FunnelViewProps } from '@funnels/ui-components/Questions/types';
import { validateSameOrFutureMonth } from '@funnels/utils';

interface InterestTypeExpiryFunnelViewProps extends FunnelViewProps, LiabilityEntityIndex {
  label?: string;
}

export const InterestTypeExpiryFunnelView = ({ liabilityIndex, label }: InterestTypeExpiryFunnelViewProps) => {
  return (
    <DatePickerInputField
      name={FIELD_PATHS.LIABILITY_FIXED_TERM_EXPIRY_DATE(liabilityIndex)}
      label={label}
      validate={validateSameOrFutureMonth('Please enter current or future expiry date')}
    />
  );
};
